import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import InitiateOTP from './pages/InitiateOTP';
import Dashboard from './pages/Dashboard';
import WheelGuide from './pages/WheelGuide';
import Survey from './pages/Survey';
import SurveyThankyou from './pages/SurveyThankyou';
import ScoreResult from './pages/ScoreResult';
import ScoreLines from './pages/ScoreLines';
import Redirector from './pages/Redirector';
import TotalScoreGraph from './pages/TotalScores';

function AppRouter(props) {
  return (
    <Router>
      <Routes>
        <Route path="/login" exact element={<Login />}></Route>
        <Route path="/" exact element={<Login />}></Route>
        <Route path="/dashboard" exact element={<Dashboard />}></Route>
        <Route path="/initiateotp" exact element={<InitiateOTP />}></Route>
        <Route path="/wheelguide" exact element={<WheelGuide />}></Route>
        <Route path="/survey" exact element={<Survey />}></Route>
        <Route
          path="/surveythankyou"
          exact
          element={<SurveyThankyou />}
        ></Route>
        <Route path="/scoreresult" exact element={<ScoreResult />}></Route>
        <Route path="/scorelines" exact element={<ScoreLines />}></Route>
        <Route path="/redirector" exact element={<Redirector />}></Route>
        <Route path="/totalscores" element={<TotalScoreGraph />} />
      </Routes>
    </Router>
  );
}
export default AppRouter;
